// One community's details key (#745), on its own below `@/hooks/communities`:
// the spec mutations (#751's rename step) patch the details cache by it, and
// they must reach it without the community reads' server functions —
// `@/hooks/specifications` is imported by suites that never stub those.

/** What every community-details key starts with — the link verbs' and the
 *  rename's write target. */
export const communityDetailsQueryKeyPrefix = ["communities", "details"] as const;

export const communityDetailsQueryKey = (communityId: number) =>
  [...communityDetailsQueryKeyPrefix, communityId] as const;
